import Vue from 'vue'
import ProjectsGrid from '../vue/Projects/ProjectsGrid'

const $appEl = document.getElementById('projects-app')

const fn = {
  init: () => {
    new Vue({
      el: $appEl,
      render: (h) => h(ProjectsGrid),
    })
  },
}

export default {
  can: () => $appEl,
  run: fn.init,
}
